import Reflux from 'reflux';

const IndexRangesActions = Reflux.createActions({
  'list': { asyncResult: true },
  'recalculate': { asyncResult: true },
  'recalculateIndex': { asyncResult: true },
});

export default IndexRangesActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/indices/IndexRangesActions.jsx